let app_ids = {
    my_attendance: 'ap00000811y6leuztymv3',
    my_team: 'ap0000081fb0vapndozhj',
    projects: 'ap0000081hbs1av7c8fg4',
    compensation: 'ap0000082w6owv96n0la4',
    payroll: 'ap0000083vamgda1helta',
    finance: 'ap0000083fttuen2l3xpx',
    company: 'ap0000083i8epvylpsowj',
    hr: 'ap0000082gumehuaw3biy',
    settings: 'ap00000809qgpcelg1rew'
}

export default app_ids